<template>
  <div class="ad-container">
    <Adsense
        data-ad-client="ca-pub-2457058330866327"
        data-ad-slot="5611925611"
        data-ad-format="auto"
        :data-full-width-responsive="true"
    >
    </Adsense>
  </div>
</template>


<script>
export default {
  name: "adsensed",
  mounted() {
  }
}
</script>
